export const DEFAULT_COLORS = {
  primary: '#9728FD',
  menu: '#2F3753',

  black: '#1C2031',
  dark1: '#2F3753',
  dark2: '#414C72',
  dark3: '#536192',
  dark4: '#6D7BAC',
  dark5: '#8D98BE',

  white: '#fff',
  light1: '#F2F3F8',
  light2: '#E4E7F1',
  light3: '#D3D7E8',
  light4: '#C6CBE1',
  light5: '#B9BFDA',

  lightGreen: '#36F78D',
  green: '#0BDA68',
  darkGreen: '#0AC25D',
  lightYellow: '#FDDF58',
  yellow: '#FDD628',
  darkYellow: '#EDC202',
  lightOrange: '#FDD928',
  orange: '#FDB628',
  darkOrange: '#FD9228',
  lightRed: '#FD8258',
  red: '#FD5D28',
  darkRed: '#ED3D02',
  lightBlue: '#588FFD',
  blue: '#286FFD',
  darkBlue: '#0251ED',
  lightPurple: '#AE58FD',
  purple: '#9728FD',
  darkPurple: '#7D02ED',
  lightCyan: '#58CCFD',
  cyan: '#28BDFD',
  darkCyan: '#02A7ED'
}

export const DEFAULT_COLORS_2 = {
  primary: '#9728FD',
  menu: '#353A4C',

  black: '#1C2031',
  dark1: '#353A4C',
  dark2: '#495069',
  dark3: '#5F6886',
  dark4: '#7982A0',
  dark5: '#969DB6',

  white: '#fff',
  light1: '#E5E7F0',
  light2: '#D5D8E7',
  light3: '#C8CDDF',
  light4: '#BCC1D7',
  light5: '#AFB5D0',

  lightGreen: '#36F78D',
  green: '#0BDA68',
  darkGreen: '#0AC25D',
  lightYellow: '#FDDF58',
  yellow: '#FDD628',
  darkYellow: '#EDC202',
  lightOrange: '#FDD928',
  orange: '#FDB628',
  darkOrange: '#FD9228',
  lightRed: '#FD8258',
  red: '#FD5D28',
  darkRed: '#ED3D02',
  lightBlue: '#588FFD',
  blue: '#286FFD',
  darkBlue: '#0251ED',
  lightPurple: '#AE58FD',
  purple: '#9728FD',
  darkPurple: '#7D02ED',
  lightCyan: '#58CCFD',
  cyan: '#28BDFD',
  darkCyan: '#02A7ED'
}

export const DARK_COLORS = {
  black: '#fff',
  dark1: '#E5E7F0',
  dark2: '#D5D8E7',
  dark3: '#C8CDDF',
  dark4: '#BCC1D7',
  dark5: '#AFB5D0',

  white: '#353A4C',
  light1: '#353A4C',
  light2: '#495069',
  light3: '#5F6886',
  light4: '#7982A0',
  light5: '#969DB6',

  lightGreen: '#30FD8C',
  green: '#02E367',
  darkGreen: '#02BB55',
  lightYellow: '#FDDF58',
  yellow: '#FDD628',
  darkYellow: '#EDC202',
  lightOrange: '#FDD928',
  orange: '#FDB628',
  darkOrange: '#FD9228',
  lightRed: '#FD8258',
  red: '#FD5D28',
  darkRed: '#ED3D02',
  lightBlue: '#588FFD',
  blue: '#286FFD',
  darkBlue: '#0251ED',
  lightPurple: '#AE58FD',
  purple: '#9728FD',
  darkPurple: '#7D02ED',
  lightCyan: '#58CCFD',
  cyan: '#28BDFD',
  darkCyan: '#02A7ED',

  primary: '#588FFD',
  menu: '#1C2031'
}

export const CYBERPUNK_COLORS = {
  primary: '#f2e900',
  menu: '#f2e900',

  black: '#f2e900',
  dark1: '#f2e900',
  dark2: '#f2e900',
  dark3: '#f2e900',
  dark4: '#f2e900',
  dark5: '#f2e900',

  white: '#000',
  light1: '#000',
  light2: '#000',
  light3: '#5F6886',
  light4: '#7982A0',
  light5: '#969DB6',

  lightGreen: '#30FD8C',
  green: '#02E367',
  darkGreen: '#02BB55',
  lightYellow: '#FDDF58',
  yellow: '#FDD628',
  darkYellow: '#EDC202',
  lightOrange: '#FDD928',
  orange: '#FDB628',
  darkOrange: '#FD9228',
  lightRed: '#FD8258',
  red: '#FD5D28',
  darkRed: '#ED3D02',
  lightBlue: '#588FFD',
  blue: '#286FFD',
  darkBlue: '#0251ED',
  lightPurple: '#AE58FD',
  purple: '#9728FD',
  darkPurple: '#7D02ED',
  lightCyan: '#58CCFD',
  cyan: '#28BDFD',
  darkCyan: '#02A7ED'
}
